import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=d5781936"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports